import { useCallback, useEffect, useState } from 'react';
import { useListAssistantSessionsQuery } from '@shared/api';

/** Ключ в localStorage: последний открытый чат Помощника (удобство, не данные). */
const KEY = 'osnova.assistant.session';

function readStored(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function writeStored(id: string | null) {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    // Приватное окно или запрет хранилища — просто не запоминаем.
  }
}

/**
 * Активный чат Помощника: общий для боковой панели и страницы «Помощник»,
 * переживает перезагрузку. Удалённый чат сбрасывается на «новый чат».
 */
export function useActiveAssistantSession(initial?: string | null) {
  const sessions = useListAssistantSessionsQuery();
  const [active, setActiveState] = useState<string | null>(() => initial ?? readStored());
  // Когда выбран чат: только список, загруженный ПОСЛЕ выбора, может сказать,
  // что чата нет. Новый чат, созданный первым вопросом, появляется в списке
  // чуть позже ответа — без этой метки выбор сбрасывался бы сразу.
  const [selectedAt, setSelectedAt] = useState(0);

  const setActive = useCallback((id: string | null) => {
    setActiveState(id);
    setSelectedAt(Date.now());
    writeStored(id);
  }, []);

  const items = sessions.data?.items;
  const fetchedAt = sessions.fulfilledTimeStamp ?? 0;
  useEffect(() => {
    if (active && items && fetchedAt > selectedAt && !items.some((s) => s.id === active)) {
      setActive(null);
    }
  }, [active, items, fetchedAt, selectedAt, setActive]);

  return { active, setActive, sessions };
}
